export const fontSizes = {
    display48: '4.8rem',  
    display40: '4.0rem', 
    heading28: '2.8rem',    
    heading24: '2.4rem', 
    heading20: '2.0rem',
    bodymedium18: '1.8rem', 
    bodynormal16: '1.6rem', 
    bodysmall14: '1.4rem',  
    bodysmall12: '1.2rem',  
  };